import ROLE from "@configs/role.ts";
import { ROUTE_ACCESS } from "@plugins/router/router.const";
import { defineAsyncComponent } from "vue";

export default [
  {
    name: "Email",
    component: defineAsyncComponent(() => import("@modules/profile/components/ProfileEmail")),
    path: "email",
    meta: {
      title: "page_title_email",
      access: ROUTE_ACCESS.PRIVILEGED_USER_TWO_FA_AUTHENTICATED,
    },
  },
  {
    name: "LinkedAccount",
    component: defineAsyncComponent(
      () => import("@modules/profile/components/ProfileLinkedAccount"),
    ),
    path: "linked-account",
    meta: { title: "page_title_linked_account", access: ROUTE_ACCESS.AUTHENTICATED },
  },
  {
    name: "Password",
    component: defineAsyncComponent(() => import("@modules/profile/components/ProfilePassword")),
    path: "password",
    meta: { title: "page_title_password", access: ROUTE_ACCESS.AUTHENTICATED },
  },
  {
    name: "SecurityQuestion",
    component: defineAsyncComponent(
      () => import("@modules/profile/components/ProfileSecurityQuestion"),
    ),
    path: "security-question",
    role: [ROLE.STUDENT],
    meta: { title: "page_title_security_question", access: ROUTE_ACCESS.AUTHENTICATED },
  },
  {
    name: "ProfileSummary",
    component: defineAsyncComponent(() => import("@modules/profile/components/ProfileSummary")),
    path: "",
    meta: { title: "page_title_profile", access: ROUTE_ACCESS.AUTHENTICATED },
  },
  {
    name: "EmailNotifications",
    component: defineAsyncComponent(
      () => import("@modules/profile/components/ProfileEmailNotifications"),
    ),
    path: "email-notification",
    meta: { title: "page_title_email_notifications", access: ROUTE_ACCESS.AUTHENTICATED },
  },
];
